/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { deletedOfferCouponsColumns } from 'pages/OfferCoupons/constants';
import { COUPONS_QUERY, DELETE_COUPON } from 'pages/OfferCoupons/CouponGraphQL';
import FSBModal from 'components/common/FSBModal';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import Loader from 'components/common/Loader';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import OfferCouponDetails from '../OfferCouponDetails';
import ShareCouponCode from '../ShareCouponCode';
import CouponCountUsers from '../CouponCountUsers';
import AddEditOfferCoupon from '../AddEditOfferCoupon';
import CouponMobileView from '../CouponMobileView';

const DeletedOfferCouponsTable = ({
  searchString,
  handleClickEdit,
  showAddRecord,
  setAddRecord,
}) => {
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'code',
        // joinAttributeName: '',
        value: searchString,
        type: 'STRING',
        op: 'LIKE',
      },
      {
        key: 'status',
        value: 'DELETED',
        type: 'BOOLEAN',
        op: 'EQ',
      },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
    pagination: true,
  });
  const [showCouponDetails, setShowCouponsDetails] = useState({
    status: false,
    row: '',
  });
  const [sharingDetails, setSharingDetails] = useState({
    status: false,
    row: '',
  });
  const toggleShowDetails = (row) => {
    setShowCouponsDetails({
      status: !showCouponDetails.status,
      row,
    });
  };
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState('');

  const { data, loading, error, refetch } = useQuery(COUPONS_QUERY, {
    variables: {
      ...filters,
      filter: [...filters.filter],
    },
    fetchPolicy: 'network-only',
  });

  const [deleteCoupon] = useMutation(DELETE_COUPON, {
    // eslint-disable-next-line no-shadow
    onCompleted: ({ deleteCoupon }) => {
      toast.success(deleteCoupon);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
      refetch();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        toast.error(message);
        return message;
      });
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },
  });

  const toggleAddRecord = (row, type = ADD_EDIT_CONSTANT.ADD) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
    refetch();
  };

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  const toggleSharingDetails = (row) => {
    setSharingDetails({
      status: !sharingDetails.status,
      row,
    });
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteCoupon({
        variables: { couponId: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  // const actionsFormatter = (cell) => {
  //   return (
  //     <ActionsFormatter
  //       isView={false}
  //       handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
  //       // handleView={() => toggleShowDetails(cell?.row?.original)}
  //       handleEdit={() =>
  //         handleClickEdit(cell?.row?.original, ADD_EDIT_CONSTANT.EDIT)
  //       }
  //     />
  //   );
  // };

  const showFormatter = (cell) => {
    return (
      <CouponCountUsers
        couponId={cell?.row?.original?.id}
        usageCount={0}
        count={
          cell?.row?.original?.usageLimit
            ? `${cell?.row?.original?.usageCount}/${cell?.row?.original?.usageLimit}`
            : 'Not Available'
        }
      />
    );
  };
  // const actionFormatter = (cell) => {
  //   return (
  //     <Button
  //       color="primary"
  //       outline
  //       size="sm"
  //       className="small-btn text-uppercase px-3 font-12"
  //       onClick={() => toggleSharingDetails(cell?.row?.original)}
  //     >
  //       Share
  //     </Button>
  //   );
  // };
  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() => toggleShowDetails(cell?.row?.original)}
        aria-hidden
      >
        {cell?.row?.original?.code}
      </div>
    );
  };

  const findIndexOfItem = (item) => {
    return deletedOfferCouponsColumns.findIndex(
      (itm) => itm.accessorKey === item,
    );
  };
  deletedOfferCouponsColumns[findIndexOfItem('code')].cell = linkFormatter;
  //   deletedOfferCouponsColumns[findIndexOfItem('action')].cell = actionFormatter;
  deletedOfferCouponsColumns[findIndexOfItem('usageLimit')].cell =
    showFormatter;

  //   deletedOfferCouponsColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  // deletedOfferCouponsColumns[findIndexOfItem('SNo')].cell = (cell) =>
  //   showSequenceNumber(cell, filters);

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.coupons?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }

  if (!data?.coupons?.coupons)
    return <NoDataFound message="Coupon Code not available" className="mt-3" />;

  return (
    <>
      <FSBModal
        size="xl"
        title={`${
          showAddRecord.type === ADD_EDIT_CONSTANT.EDIT
            ? showAddRecord.type
            : ADD_EDIT_CONSTANT.ADD
        } Coupon`}
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showAddRecord.status}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        modalClass="right-drawer right-drawer-details"
      >
        <AddEditOfferCoupon
          currentRow={showAddRecord.row}
          type={showAddRecord.type}
          drawerToggle={toggleAddRecord}
        />
      </FSBModal>
      <FSBModal
        size="xl"
        title="Coupon Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showCouponDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer right-drawer-details"
      >
        <OfferCouponDetails coupon={showCouponDetails?.row} />
      </FSBModal>

      <FSBModal
        size="xl"
        title="Share Coupon Code"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={sharingDetails.status}
        toggleAlert={toggleSharingDetails}
        onClose={toggleSharingDetails}
        modalClass="right-drawer right-drawer-details"
      >
        <ShareCouponCode
          onCloseUpdatePopup={toggleSharingDetails}
          currentRow={sharingDetails.row}
        />
      </FSBModal>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <CouponMobileView
        data={data?.coupons?.coupons || []}
        toggleShowDetails={toggleShowDetails}
        toggleSharingDetails={toggleSharingDetails}
        toggleDeleteRecord={toggleDeleteRecord}
        handleClickEdit={handleClickEdit}
        totalCount={data?.coupons?.totalCount || 0}
        pageSize={filters.pageSize}
        currentPageNo={filters.pageNo}
        handlePageChange={handlePageChange}
        hideActions
      />

      <div className="dashboard-mobile-hide-table">
        <FSBTable
          data={data?.coupons?.coupons || []}
          totalCount={data?.coupons?.totalCount}
          totalPages={data?.coupons?.totalPages}
          columns={deletedOfferCouponsColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
        />
      </div>
    </>
  );
};
export default DeletedOfferCouponsTable;
